<template>
  <div>
    <back :title="titlename"></back>
    <!-- 预约办 -->
    <van-form @submit="onSubmit">
      <van-field v-model.trim="name" name="姓名" label="姓名" placeholder="请填写" />
      <van-field readonly clickable name="picker" :value="sqvalue"  label="所属社区" placeholder="请选择" @click="showPicker1 = true" />
      <van-field readonly clickable name="picker" :value="value" label="预约网络点" placeholder="请选择" @click="showPicker = true" />
      <van-field v-model.trim="phone" type="number" name="联系电话" label="联系电话" placeholder="请填写" />
      <van-field readonly clickable name="pickertime" :value="time" label="预约办理日期" placeholder="请选择" @click="showtime = true" />
      <van-field readonly clickable name="pickertime" :value="hour" label="预约办理时间" placeholder="请选择" @click="showhour = true" />
      <div class="textarea">
        <p>预约办理备注</p>
        <textarea v-model="content" name="" id="" placeholder="请填写"></textarea>
      </div>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
      <!-- 预约社区下拉框选项 -->
      <van-popup v-model="showPicker1" position="bottom">
        <van-picker show-toolbar :columns="districtList" value-key="name" @confirm="onConfirm1" @cancel="showPicker1 = false" />
      </van-popup>
      <!-- 预约网络点下拉框选项 -->
      <van-popup v-model.trim="showPicker" position="bottom">
        <van-picker show-toolbar :columns="columns" value-key="name" @confirm="onConfirm" @cancel="showPicker = false" />
      </van-popup>
      <!-- 时间下拉 -->
      <van-popup v-model="showtime" position="bottom">
        <van-picker title="选择日期" show-toolbar :columns="datelist" @confirm="onConfirmtime" @cancel="showtime = false" />
         <!-- <van-datetime-picker  :max-hour="16" :min-hour="8" type="time" @confirm="onConfirmtime" @cancel="showtime = false" /> -->
      </van-popup>
      <van-popup v-model="showhour" position="bottom">
        <van-picker title="选择时间" show-toolbar :columns="timelist" @confirm="onConfirmhour" @cancel="showhour=false" />
      </van-popup>
    </van-form>
  </div>

</template>

<script>
  import { Form,Toast } from 'vant'
  export default {
    data() {
      return {
        titlename: "网格办",
        name:"",
        phone:"",
        value: '',
        columns: [],
        showPicker: false,
        time:"",
        showtime: false,
        content:"",
        minDate: new Date(),
        maxDate: new Date(),
        districtList:"",
        sqvalue:"",
        showPicker1: false,
        sqid:"",
        wgid:"",
        hour:"",
        showhour:false,
        timelist:[],
        datelist:[]
      };
    },
    created:function(){
      this.getperinfo()
      this.getList(1)
      var date=new Date()
      console.log(date.getDate()+3)
      this.maxDate=new Date(date.getFullYear(),date.getMonth(),date.getDate()+5)
    },
    methods: {
      // 获取个人信息
      getperinfo(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.$store.state.openId},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.name=res.body.userPd.realname
            this.phone=res.body.userPd.phone
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      // 获取社区
      getList(obj){
        this.$http.post(this.$store.state.host+"/interface/districtList",{DISTRICT_ID:obj},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            if(obj==1){
              this.districtList=res.body.list
            }
            else{
              this.columns=res.body.list
              console.log(res.body.list)
              //this.timelist=res.body.list[0].timeList
              //this.datelist=res.body.list[0].dateList
            }
          }
        },res=>{
           //发送失败
        })
      },
      //社区赋值
      onConfirm1(value) {
        this.sqvalue = value.name;
        this.sqid=value.district_ID
        console.log(this.sqid)
        this.showPicker1 = false;
        this.getList(value.district_ID)
        this.value=""//清空网格名称
        this.wgid=""//清空网格id
        this.time=""
        this.hour=""
        this.timelist=[]
        this.datelist=[]
      },
      //预约网点赋值
      onConfirm(value) {
        this.$http.post(this.$store.state.host+"/interface/districtInfo",{DISTRICT_ID:value.district_ID},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(132124)
          console.log(res)
          if(res.body.code==0){
              this.timelist=res.body.info.timelist
              this.datelist=res.body.info.dateList
          }
        },res=>{
           //发送失败
        })
        this.value = value.name;
        this.showPicker = false;
        this.wgid=value.district_ID

      },
      //时间赋值
      onConfirmtime(value) {
        //var time = new Date()
        // var year = value.getFullYear()//年
        // var month = value.getMonth() + 1//月
        // month=month>9?month:'0'+month//小于10加前缀0
        // var day = value.getDate()
        // day=day>9?day:'0'+day//小于10加前缀0
        // let hour=value.getHours()
        // hour=hour>9?hour:'0'+hour
        // let minute=value.getMinutes()
        // minute=minute>9?minute:'0'+minute
        // this.time = year+'-'+month+'-'+day+' '+hour+':'+minute
        this.time = value
        console.log(value)
        this.showtime = false;
      },
      onConfirmhour(value){
        this.hour=value
        this.showhour=false
      },
      // 提交
      onSubmit(){
        Toast.loading({
          message: '提交中...',
          forbidClick: true,
          duration:0
        });
        if(this.name==""||this.name==undefined){
          Toast("请输入姓名")
          return false
        }
        if(this.value==""||this.value==undefined){
          Toast("请选择预约网点")
          return false
        }
        if(this.phone==""||this.phone==undefined){
          Toast("请输入手机号")
          return false
        }
        if(this.phone.length!=11){
          Toast("手机号格式不正确，请重新输入")
          return false
        }
        if(this.time==""||this.time==undefined){
          Toast("请选择办理日期")
          return false
        }
        if(this.hour==""||this.hour==undefined){
          Toast("请选择办理时间")
          return false
        }
        this.$http.post(this.$store.state.host+"/interface/yybSave",
        {OPENID:this.$store.state.openId,
         USERNAME:this.name,
         PHONE:this.phone,
         SQID:this.sqid,
         SQNAME:this.sqvalue,
         WDID:this.wgid,
         WDNAME:this.value,
         BEIZHU:this.content,
         YYTIME:this.time+' '+this.hour,
         SHIXIANGID:this.$route.query.sxid},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            Toast.success('提交成功');
            this.$router.push("/Yw")
          }
          else{
            Toast.fail(res.body.msg);
          }

          //if()
        },res=>{
           //发送失败
        })
      }
    }
  };
</script>

<style lang="less" scoped>
  /deep/.van-form{
    .van-button--info{
      background-color: #f28033;
      border: 1px solid #f28033;
      border-radius: 5px;
    }
    .van-cell{
      font-size: .26rem;
      }
    .textarea{
      font-size: .26rem;
      padding: 10px 16px;
      color: #646566;
      textarea{
        width: 98%;
        height: 150px;
        border-color: #e5e5e5;
        color: #999999;
        margin-top: 16px;
        padding: 10px 1%;
      }
    }
  }
  /deep/.van-field__control{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/pages/appointment.vue